import React from 'react';
import type { TransformedReport } from '../types';

interface CoverSlideProps {
  data: TransformedReport;
}

/**
 * CoverSlide - Slide 1: Cover page with company name, product name, and date.
 */
const CoverSlide: React.FC<CoverSlideProps> = ({ data }) => {
  const companyName = data.meta.company_name || '';
  const productName = data.service_info.product_name || data.service_info.brand || '';
  const createdAt = data.meta.created_at
    ? new Date(data.meta.created_at).toLocaleDateString('ja-JP', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      }).replace(/\//g, '.')
    : '';

  return (
    <div className="flex flex-col" style={{ paddingBottom: 0, background: '#F6F5F0', color: '#1D1926', height: '100%' }}>
      {/* Title area */}
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
        {companyName && (
          <p style={{ fontSize: 'clamp(12px, 1.8vmin, 16px)', fontWeight: 600, color: 'rgba(29,25,38,0.5)', marginBottom: 'clamp(8px, 1.2vmin, 16px)' }}>
            {companyName} 御中
          </p>
        )}
        <h1 style={{ fontSize: 'clamp(28px, 6vmin, 64px)', fontWeight: 700, lineHeight: 1.2, letterSpacing: '-0.02em', marginBottom: 'clamp(8px, 1.2vmin, 16px)' }}>
          {productName && <>{productName}<br /></>}
          広告バナー戦略のご提案
        </h1>
        <p style={{ fontSize: 'clamp(9px, 1.4vmin, 13px)', fontWeight: 600, letterSpacing: '0.15em', textTransform: 'uppercase', fontFamily: 'Inter, sans-serif', color: 'rgba(29,25,38,0.3)', marginBottom: 'clamp(12px, 1.8vmin, 24px)' }}>
          Advertising Creative Strategy Report
        </p>
        <div style={{ width: 48, height: 3, background: '#3eb298' }} />
      </div>

      {/* Bottom meta */}
      <div style={{ borderTop: '1px solid rgba(29,25,38,0.1)', paddingTop: 'clamp(14px, 2vmin, 24px)', paddingBottom: 'clamp(14px, 2vmin, 24px)' }}>
        <div>
          <p style={{ fontSize: 11, color: 'rgba(29,25,38,0.35)', textTransform: 'uppercase', letterSpacing: '0.08em', fontFamily: 'Inter, sans-serif', marginBottom: 4 }}>
            Date
          </p>
          <p style={{ fontSize: 15, fontWeight: 600, fontFamily: 'Inter, sans-serif' }}>
            {createdAt}
          </p>
        </div>
      </div>
    </div>
  );
};

export default CoverSlide;
